import { FC } from 'react';
import { Input, InputProps } from 'antd';
import { PatternFormat, NumericFormat } from 'react-number-format';

interface ISInput extends InputProps {
  allowNegative?: boolean;
}

const SInput: FC<ISInput> = (props) => {
  const { type, value, defaultValue, onChange, allowNegative, ...restProps } =
    props;

  const rawValue = Array.isArray(value) ? undefined : value;
  const rawDefaultValue = Array.isArray(defaultValue)
    ? undefined
    : defaultValue;

  const numericValue: string | number | null | undefined =
    typeof rawValue === 'bigint'
      ? rawValue.toString()
      : (rawValue as string | number | null | undefined);

  const validDefaultValue: string | number | null | undefined =
    typeof rawDefaultValue === 'bigint'
      ? (rawDefaultValue as bigint).toString()
      : (rawDefaultValue as string | number | null | undefined);

  if (props.name === 'gsm') {
    return (
      <PatternFormat
        format="0### ### ####"
        mask="_"
        allowEmptyFormatting
        value={numericValue as any}
        defaultValue={validDefaultValue as any}
        customInput={Input}
        inputMode="numeric"
        {...restProps}
        onValueChange={(values) => {
          const syntheticEvent = {
            target: {
              name: (props as any).name,
              value: values.value,
            },
          };
          onChange?.(syntheticEvent as any);
        }}
      />
    );
  }

  if (type === 'number') {
    const { suffix, prefix, status, rootClassName, ...inputOnlyProps } =
      restProps;

    return (
      <NumericFormat
        value={numericValue}
        defaultValue={validDefaultValue}
        decimalSeparator=","
        thousandSeparator="."
        allowNegative={allowNegative ?? false}
        customInput={Input}
        {...inputOnlyProps}
        onValueChange={(values) => {
          const syntheticEvent = {
            target: {
              name: props.name,
              value: values.floatValue ?? values.value,
            },
          };
          onChange?.(syntheticEvent as any);
        }}
      />
    );
  }

  return <Input {...props} />;
};

export default SInput;
